import { forwardRef, type InputHTMLAttributes } from 'react';
import { cn } from '@/lib/cn';

interface InputProps extends InputHTMLAttributes<HTMLInputElement> {
  invalid?: boolean;
}

export const Input = forwardRef<HTMLInputElement, InputProps>(function Input(
  { className, invalid, ...rest },
  ref,
) {
  return (
    <input
      ref={ref}
      className={cn(
        'w-full rounded-[4px] border bg-white dark:bg-[#1A1A2E] px-3 py-2 text-sm text-[#12122C] dark:text-white placeholder-[#BABACE] dark:placeholder-[#8888AA]',
        'focus:outline-none focus:ring-[3px] focus:ring-[#3F4CFF]/16 focus:border-[#3F4CFF]',
        'disabled:bg-[#EFF0FF] dark:disabled:bg-white/5 disabled:text-[#BABACE] dark:disabled:text-[#8888AA] disabled:border-[#E3E3F1]',
        'transition-shadow transition-colors duration-100',
        invalid
          ? 'border-[#DC2626] focus:ring-[#DC2626]/12 focus:border-[#DC2626]'
          : 'border-[#BABACE] dark:border-[#2A2A4A]',
        className,
      )}
      {...rest}
    />
  );
});
